import React, {Component} from 'react';
import {connect} from 'react-redux';
import pick from 'lodash.pick';

import {Field, reduxForm} from 'redux-form';
import {
    Button,
    Col,
    Row
} from 'reactstrap';

import PolyUtil from '../../../../util/PolyUtil';
import {InputField, SelectField} from "../../../../validation/ReduxFormInput";
import {normalizePhone} from "../../../../util/normalizers";
import {guarantorRelationships} from "../../../../util/FormConstants";
import {handleSubmitGuarantorInfo} from "../../actions/application";

class GuarantorFrame extends Component {
    render() {
        const {handleSubmit, _handleSubmitGuarantorInfo, submitting, pristine} = this.props;

        return (
            <div>
                <form onSubmit={handleSubmit(_handleSubmitGuarantorInfo)}>
                    <Row>
                        <Col xs={12} sm={6}><Field name="first_name" label="First Name" component={InputField} type="text"/></Col>
                        <Col xs={12} sm={6}><Field name="last_name" label="Last Name" component={InputField} type="text"/></Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6}><Field name="email" label="Email" component={InputField} type="email"/></Col>
                        <Col xs={12} sm={6}><Field name="phone" label="Phone" component={InputField} placeholder="555-555-5555" normalize={normalizePhone}/></Col>
                    </Row>
                    <Row>
                        <Col><Field name="relation" label="Relationship to Applicant" component={SelectField} options={guarantorRelationships}/></Col>
                    </Row>

                    <div className="center">
                        <Button color="success" type="submit" disabled={submitting || pristine} style={{marginBottom: '2em'}} outline>Continue</Button>
                    </div>
                </form>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};

    !values.first_name && (errors.first_name = 'Required');
    !values.last_name && (errors.last_name = 'Required');
    !values.phone && (errors.phone = 'Required');
    (values.phone && values.phone.length !== 12) && (errors.phone = 'Please enter a valid phone number');
    !values.email && (errors.email = 'Required');

    (!values.relation || values.relation === 'default') && (errors.relation = 'Required');

    return errors;
};

GuarantorFrame = reduxForm({
    form: 'application_guarantor',
    validate
})(GuarantorFrame);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        _handleSubmitGuarantorInfo(data) {
            dispatch(handleSubmitGuarantorInfo(data));
        }
    };
};

//Get initial form values from state
GuarantorFrame = connect(state => {
        let initial = state.tenant.application.guarantor ? Object.assign({}, pick(state.tenant.application.guarantor, [
                'first_name',
                'last_name',
                'email',
                'phone',
                'relation'
            ]
        )) : {};

        initial.phone && (initial.phone = PolyUtil.formatPhone(initial.phone));

        return {
            initialValues: initial
        };
    }
)(GuarantorFrame);

export default connect(mapStateToProps, mapDispatchToProps)(GuarantorFrame);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/GuarantorFrame.js